(() => {
  const theme = window.theme || {};
  const moneyFormat = theme.moneyFormat || "${{amount}}";

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function formatMoney(cents, format = moneyFormat) {
    if (cents == null || cents === "") return "";
    let value = typeof cents === "string" ? cents : String(cents);
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    const amount = (num / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(num / 100));
    const withComma = amount.replace(".", ",");
    const withApostrophe = amount.replace(".", "'");
    const parts = amount.split(".");
    const withSpace = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "." + parts[1];
    return String(format)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withApostrophe)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withSpace)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, (ch) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }[ch]));
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle("is-locked", on);
  }

  let lastFocus = null;

  function openLayer(panel) {
    if (!panel) return;
    lastFocus = document.activeElement;
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add("is-open"));
    const overlay = $("[data-overlay]");
    if (overlay && panel.matches(".drawer, .nav-panel")) {
      overlay.hidden = false;
      overlay.classList.add("is-open");
      lockScroll(true);
    }
    const focusTarget = panel.querySelector("[data-autofocus], input, button, a");
    if (focusTarget) focusTarget.focus();
  }

  function closeLayer(panel) {
    if (!panel) return;
    panel.classList.remove("is-open");
    const overlay = $("[data-overlay]");
    const anyOpen = $(".drawer.is-open, .nav-panel.is-open");
    if (!anyOpen && overlay) {
      overlay.classList.remove("is-open");
      lockScroll(false);
    }
    window.setTimeout(() => {
      if (!panel.classList.contains("is-open")) panel.hidden = true;
      if (overlay && !overlay.classList.contains("is-open")) overlay.hidden = true;
    }, 280);
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  }

  function closeAll() {
    $$(".drawer.is-open, .nav-panel.is-open, .search-panel.is-open").forEach((panel) => {
      panel.classList.remove("is-open");
      if (!panel.classList.contains("search-panel")) {
        window.setTimeout(() => {
          if (!panel.classList.contains("is-open")) panel.hidden = true;
        }, 280);
      } else {
        panel.hidden = true;
      }
    });
    const overlay = $("[data-overlay]");
    if (overlay) {
      overlay.classList.remove("is-open");
      overlay.hidden = true;
    }
    lockScroll(false);
    const menuBtn = $("[data-menu-open]");
    if (menuBtn) menuBtn.setAttribute("aria-expanded", "false");
    const searchBtn = $("[data-search-open]");
    if (searchBtn) searchBtn.setAttribute("aria-expanded", "false");
  }

  function updateCounts(count) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = String(count);
      el.hidden = !(count > 0);
    });
    $$("[data-cart-open], [data-cart-link]").forEach((el) => {
      if (el.hasAttribute("data-count-label")) {
        const tmpl = el.getAttribute("data-count-label");
        el.setAttribute("aria-label", tmpl.replace("[[count]]", String(count)));
      }
    });
  }

  function lineHtml(item) {
    const img = item.image
      ? `<img src="${escapeHtml(item.image)}" alt="" width="84" height="84">`
      : `<span class="cart-line__ph"></span>`;
    const variant = item.variant_title && item.variant_title !== "Default Title"
      ? `<p class="cart-line__meta">${escapeHtml(item.variant_title)}</p>`
      : "";
    const price = item.original_line_price > item.final_line_price
      ? `<s>${formatMoney(item.original_line_price)}</s> ${formatMoney(item.final_line_price)}`
      : formatMoney(item.final_line_price);
    return `
      <article class="cart-line">
        <a href="${escapeHtml(item.url)}">${img}</a>
        <div>
          <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title || item.title)}</a></h3>
          ${variant}
          <div class="cart-line__row">
            <div class="qty">
              <div class="qty__control">
                <button type="button" data-qty-btn="-1" aria-label="${escapeHtml(theme.strings.decrease)}">−</button>
                <input type="number" min="0" value="${item.quantity}" data-line-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(theme.strings.quantity)}">
                <button type="button" data-qty-btn="1" aria-label="${escapeHtml(theme.strings.increase)}">+</button>
              </div>
            </div>
            <strong>${price}</strong>
          </div>
          <button type="button" class="cart-line__remove" data-cart-remove="${escapeHtml(item.key)}">${escapeHtml(theme.strings.remove)}</button>
        </div>
      </article>`;
  }

  function renderCart(cart) {
    const body = $("[data-cart-body]");
    const subtotal = $("[data-cart-subtotal]");
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    updateCounts(cart.item_count);
    const foot = $("[data-cart-foot]");
    if (foot) foot.hidden = !(cart.items && cart.items.length);
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = `
        <div class="cart-empty">
          <h3>${escapeHtml(theme.strings.cartEmpty)}</h3>
          <p class="muted">${escapeHtml(theme.strings.cartEmptyNote)}</p>
          <a class="btn" href="${escapeHtml(theme.routes.allProducts || "/collections/all")}">${escapeHtml(theme.strings.continue)}</a>
        </div>`;
      return;
    }
    body.innerHTML = cart.items.map(lineHtml).join("");
  }

  async function fetchCart() {
    const res = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("cart");
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch(`${theme.routes.cartChange}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error("change");
    return res.json();
  }

  function initHeader() {
    const header = $("[data-header]");
    if (!header) return;
    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    const menu = $("[data-menu]");
    const menuBtn = $("[data-menu-open]");
    if (menuBtn && menu) {
      menuBtn.addEventListener("click", () => {
        const open = menuBtn.getAttribute("aria-expanded") === "true";
        if (open) {
          closeLayer(menu);
          menuBtn.setAttribute("aria-expanded", "false");
        } else {
          closeAll();
          menu.hidden = false;
          openLayer(menu);
          menuBtn.setAttribute("aria-expanded", "true");
        }
      });
    }

    const search = $("[data-search]");
    const searchBtn = $("[data-search-open]");
    if (searchBtn && search) {
      searchBtn.addEventListener("click", () => {
        const open = searchBtn.getAttribute("aria-expanded") === "true";
        if (open) {
          search.classList.remove("is-open");
          search.hidden = true;
          searchBtn.setAttribute("aria-expanded", "false");
        } else {
          closeAll();
          search.hidden = false;
          search.classList.add("is-open");
          searchBtn.setAttribute("aria-expanded", "true");
          const input = search.querySelector("input[type='search']");
          if (input) input.focus();
        }
      });
    }

    $$("[data-close-layer]").forEach((btn) => {
      btn.addEventListener("click", () => {
        closeAll();
      });
    });

    const overlay = $("[data-overlay]");
    if (overlay) overlay.addEventListener("click", closeAll);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeAll();
      if (event.key === "/" && !event.metaKey && !event.ctrlKey && search && searchBtn) {
        const tag = document.activeElement && document.activeElement.tagName;
        if (tag === "INPUT" || tag === "TEXTAREA") return;
        event.preventDefault();
        searchBtn.click();
      }
    });
  }

  function initSearch() {
    const input = $("[data-predictive-input]");
    const results = $("[data-predictive-results]");
    if (!input || !results || !theme.routes.predictiveSearch) return;
    let timer = null;
    input.addEventListener("input", () => {
      window.clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = "";
        return;
      }
      timer = window.setTimeout(async () => {
        const url = `${theme.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search`;
        try {
          const res = await fetch(url, { headers: { Accept: "text/html" } });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, "text/html");
          const inner = doc.querySelector("[data-predictive-inner]");
          results.innerHTML = inner ? inner.innerHTML : "";
        } catch (err) {
          results.innerHTML = "";
        }
      }, 220);
    });
  }

  function initCart() {
    const drawer = $("[data-cart-drawer]");
    if (!drawer || theme.cartDrawer === false) return;

    async function openCart() {
      try {
        const cart = await fetchCart();
        renderCart(cart);
      } catch (err) {
        /* keep server-rendered contents */
      }
      closeAll();
      drawer.hidden = false;
      openLayer(drawer);
    }

    $$("[data-cart-open]").forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        openCart();
      });
    });

    drawer.addEventListener("change", async (event) => {
      const input = event.target.closest("[data-line-key]");
      if (!input) return;
      const key = input.getAttribute("data-line-key");
      const qty = Math.max(0, Number(input.value) || 0);
      try {
        const cart = await changeLine(key, qty);
        renderCart(cart);
      } catch (err) {
        input.setCustomValidity?.("Could not update");
      }
    });

    drawer.addEventListener("click", async (event) => {
      const btn = event.target.closest("[data-cart-remove]");
      if (!btn) return;
      try {
        const cart = await changeLine(btn.getAttribute("data-cart-remove"), 0);
        renderCart(cart);
      } catch (err) {
        /* ignore */
      }
    });

    const note = $("[data-cart-note]");
    if (note) {
      let noteTimer = null;
      note.addEventListener("input", () => {
        window.clearTimeout(noteTimer);
        noteTimer = window.setTimeout(() => {
          fetch(`${theme.routes.cartUpdate}.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ note: note.value })
          }).catch(() => {});
        }, 400);
      });
    }

    document.addEventListener("cart:open", openCart);
  }

  function initQty() {
    document.addEventListener("click", (event) => {
      const btn = event.target.closest("[data-qty-btn]");
      if (!btn) return;
      const wrap = btn.closest(".qty__control");
      const input = wrap && wrap.querySelector("input");
      if (!input) return;
      const dir = Number(btn.getAttribute("data-qty-btn"));
      const min = input.min === "" ? 0 : Number(input.min);
      const max = input.max === "" ? Infinity : Number(input.max);
      const next = Math.min(max, Math.max(min, (Number(input.value) || 0) + dir));
      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function initProductForms() {
    $$("form.product-form").forEach((form) => {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const button = form.querySelector("[data-add-button]");
        const message = form.querySelector("[data-form-message]");
        const original = button ? button.textContent : "";
        if (button) {
          button.disabled = true;
          button.textContent = theme.strings.adding || "Adding…";
        }
        if (message) message.textContent = "";
        try {
          const data = new FormData(form);
          data.delete("form_type");
          data.delete("utf8");
          data.delete("authenticity_token");
          const res = await fetch(`${theme.routes.cartAdd}.js`, {
            method: "POST",
            headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
            body: new URLSearchParams(data)
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || err.message || theme.strings.unavailable);
          }
          const cart = await fetchCart();
          renderCart(cart);
          if (theme.cartDrawer !== false && $("[data-cart-drawer]")) {
            closeAll();
            const drawer = $("[data-cart-drawer]");
            drawer.hidden = false;
            openLayer(drawer);
          } else {
            window.location.href = theme.routes.cart;
          }
        } catch (err) {
          if (message) message.textContent = err.message || theme.strings.unavailable;
        } finally {
          if (button) {
            button.disabled = button.hasAttribute("data-sold-out");
            button.textContent = original;
          }
        }
      });
    });
  }

  function initVariants() {
    $$("[data-product-section]").forEach((root) => {
      const jsonEl = root.querySelector("[data-product-json]");
      if (!jsonEl) return;
      let product;
      try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
      const form = root.querySelector("form.product-form");
      if (!form) return;
      const idInput = form.querySelector("[name='id']");
      const priceEl = root.querySelector("[data-price]");
      const compareEl = root.querySelector("[data-compare]");
      const button = form.querySelector("[data-add-button]");
      const skuEl = root.querySelector("[data-sku]");

      function selectedOptions() {
        const opts = [];
        $$("[data-option-index]", root).forEach((input) => {
          if (input.checked) opts[Number(input.getAttribute("data-option-index"))] = input.value;
        });
        const select = root.querySelector("[data-option-select]");
        if (select) opts[Number(select.getAttribute("data-option-index"))] = select.value;
        return opts;
      }

      function findVariant() {
        const opts = selectedOptions();
        if (!opts.length) return product.variants.find((v) => String(v.id) === String(idInput.value)) || product.variants[0];
        return product.variants.find((variant) => {
          return opts.every((value, index) => variant.options[index] === value);
        });
      }

      function applyVariant(variant) {
        if (!variant) {
          if (button) {
            button.disabled = true;
            button.textContent = theme.strings.unavailable;
          }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price, theme.moneyWithCurrencyFormat || moneyFormat);
        if (compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareEl.hidden = false;
            compareEl.textContent = formatMoney(variant.compare_at_price, theme.moneyWithCurrencyFormat || moneyFormat);
          } else {
            compareEl.hidden = true;
          }
        }
        if (skuEl) skuEl.textContent = variant.sku || "";
        if (button) {
          const sold = !variant.available;
          button.disabled = sold;
          button.toggleAttribute("data-sold-out", sold);
          button.textContent = sold ? theme.strings.soldOut : theme.strings.addToCart;
        }
        if (variant.featured_media) {
          const id = variant.featured_media.id;
          const slide = root.querySelector(`[data-media-id="${id}"]`);
          if (slide) {
            $$("[data-media-id]", root).forEach((el) => el.classList.remove("is-active"));
            slide.classList.add("is-active");
            const thumb = root.querySelector(`[data-thumb="${id}"]`);
            if (thumb) {
              $$("[data-thumb]", root).forEach((el) => el.classList.remove("is-active"));
              thumb.classList.add("is-active");
            }
          }
        }
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      }

      root.addEventListener("change", (event) => {
        if (!event.target.closest("[data-variant-picker]")) return;
        applyVariant(findVariant());
      });
    });

    $$("[data-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const root = thumb.closest("[data-product-section]") || document;
        const id = thumb.getAttribute("data-thumb");
        $$("[data-media-id]", root).forEach((el) => el.classList.toggle("is-active", el.getAttribute("data-media-id") === id));
        $$("[data-thumb]", root).forEach((el) => el.classList.toggle("is-active", el === thumb));
      });
    });
  }

  function initRecommendations() {
    const root = $("[data-recommendations-root]");
    if (!root || root.querySelector("[data-recommendations-inner]") || !root.dataset.url) return;
    fetch(root.dataset.url)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const inner = doc.querySelector("[data-recommendations-inner]");
        if (inner) root.innerHTML = inner.outerHTML;
      })
      .catch(() => {});
  }

  function initReveal() {
    const nodes = $$(".rise-in");
    if (!nodes.length || !("IntersectionObserver" in window)) {
      nodes.forEach((node) => node.classList.add("is-in"));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });
    nodes.forEach((node) => io.observe(node));
  }

  function initCartPage() {
    const page = $("[data-cart-page]");
    if (!page) return;
    page.addEventListener("change", async (event) => {
      const input = event.target.closest("[data-line-key]");
      if (!input || input.closest("[data-cart-drawer]")) return;
      try {
        await changeLine(input.getAttribute("data-line-key"), Math.max(0, Number(input.value) || 0));
        window.location.reload();
      } catch (err) {
        /* form update still works */
      }
    });
  }

  function init() {
    initHeader();
    initSearch();
    initCart();
    initQty();
    initProductForms();
    initVariants();
    initRecommendations();
    initReveal();
    initCartPage();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
